import Controller from "./corporate.controller";
import template from "./corporate.html";

const corporate = {
  template,
  controller: Controller,
};

export default corporate;



// WEBPACK FOOTER //
// ./src/pages/corporate/corporate.component.js